export default __webpack_public_path__ + "static/media/html_pricing.b3498016.md";